import { cn } from "@/lib/utils";
import { ComponentProps } from "react";

import { ToggleIcon } from "./ToggleIcon";

export function BookmarkIconButton({
    variant = "filled",
    className,
    ...props
}: {
    variant?: "filled" | "icon";
} & Omit<ComponentProps<typeof ToggleIcon>, "iconSpec">) {
    const iconSpec = (
        {
            filled: {
                unchecked: {
                    name: "BookmarkOutlined" as IconName,
                    enabled: {
                        color: "grey-500",
                        backgroundColor: "white",
                        borderRadius: 8
                    },
                    hover: {
                        color: "grey-300",
                        backgroundColor: "white"
                    }
                },
                checked: {
                    name: "BookmarkFilled" as IconName,
                    enabled: {
                        color: "var(--subcolor-orange)",
                        backgroundColor: "white",
                        borderRadius: 8
                    },
                    hover: {
                        color: "var(--subcolor-orange)",
                        backgroundColor: "white"
                    }
                }
            },
            icon: {
                unchecked: {
                    name: "BookmarkOutlined" as IconName,
                    enabled: {
                        color: "grey-500",
                        backgroundColor: "transparent",
                        borderRadius: 8
                    },
                    hover: {
                        color: "grey-300",
                        backgroundColor: "transparent"
                    }
                },
                checked: {
                    name: "BookmarkFilled" as IconName,
                    enabled: {
                        color: "var(--subcolor-orange)",
                        backgroundColor: "transparent",
                        borderRadius: 8
                    },
                    hover: {
                        color: "var(--subcolor-orange)",
                        backgroundColor: "transparent"
                    }
                }
            }
        } as const
    )[variant];

    return (
        <ToggleIcon
            iconSpec={iconSpec}
            className={cn(variant === "icon" && "border-0", className)}
            {...props}
        />
    );
}
